import { ChannelSchema } from "@redotech/redo-model/marketplace/channels";
import * as z from "zod";

const MarketplaceListingSchema_ = z.object({
  id: z.string(),
  channel: ChannelSchema,
  productId: z.string(),
  title: z.string(),
  price: z.string(),
  availableQuantity: z.number(),
  sku: z.string().nullable(),
  marketplaceId: z.string(),
  accountId: z.string(),
  catalogId: z.string(),
  imageUrl: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const getMarketplaceListings = {
  name: "getMarketplaceListings" as const,
  input: z.object({
    cursor: z.string().optional(),
    pageSize: z.number().optional(),
  }),
  output: z.object({
    listings: z.array(MarketplaceListingSchema_),
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
    totalCount: z.number(),
  }),
};
